import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COLLABORATOR_I18N_KEY } from "./constants";
var es = /*#__PURE__*/_defineProperty({}, COLLABORATOR_I18N_KEY, {
  KH_CLOSE: 'Cerrar',
  KH_LAST_UPDATED: 'Actualizado el: {{date}}',
  KH_MODULES: 'Módulos',
  KH_RATING: 'Valoración',
  KH_STUDENTS: 'Estudiantes',
  KH_COURSE_SEE_DETAIL: 'Ver detalle',
  KH_SEE_CATALOG: 'Ver catálogo',
  KH_COURSE_ENROLL: 'Inscribirse',
  KH_SEARCH: 'Buscar',
  KH_FILTER_CATEGORY_ALL: 'Todos',
  KH_SEARCH_SUCCESS_RESULTS: 'Resultados de tu búsqueda',
  KH_SEARCH_NO_RESULTS: 'No se encontraron resultados',
  KH_SEARCH_X_RESULTS: '{{count}} resultado',
  KH_SEARCH_X_RESULTS_plural: '{{count}} resultados',
  KH_SEARCH_NO_RESULTS_FOR: 'No se encontraron resultados para "{{query}}"',
  KH_SEARCH_NO_RESULTS_ACTION: 'Intenta con otra palabra',
  KH_SEARCH_PLACEHOLDER: '¿Qué deseas buscar?',
  KH_SEARCH_PLACEHOLDER_SHORT: '¿Qué buscas?',
  KH_SEARCH_CLEAR: 'Limpiar búsqueda',
  KH_FILTER_TITLE: 'Filtros',
  KH_FILTER_CTA: 'Filtrar',
  KH_FILTER_ITEM_CATEGORIES: 'Categorías',
  KH_FILTER_ITEM_PROVIDER: 'Aliados',
  KH_FILTER_ITEM_LEVELS: 'Niveles',
  KH_FILTER_ITEM_LANGUAGES: 'Idiomas',
  KH_FILTER_ITEM_CONTENT_TYPES: 'Tipo de contenido',
  KH_FILTER_INITIAL_CTA: 'Filtrar por',
  KH_FILTER_VIEW_ALL: 'Ver todos',
  KH_SORTING_INITIAL_CTA: 'Ordenar por',
  KH_SORTING_AZ: 'De la A-Z',
  KH_SORTING_ZA: 'De la Z-A',
  KH_COURSE: 'Curso',
  KH_CONTENTS_CATEGORY_LABEL: 'Contenidos',
  KH_CONTENT_CATEGORY_LABEL: 'Contenido',
  KN_DOCUMENT: 'Documento',
  KN_DOWNLOAD: 'Descargar',
  DUD_DOCUMENTS_PREVIEW_CTA: 'Visualizar',
  KH_BREADCRUMB_HOME: 'Inicio',
  KH_BREADCRUMB_CATALOG: 'Catálogo',
  KH_BREADCRUMB_INTEREST_CONTENT: 'Contenido de Crehana',
  KH_BREADCRUMB_ONLY: 'Contenido de {{name}}',
  KH_BREADCRUMB_THIRD_PARTY_CONTENT: 'Contenidos de Aliados',
  KH_COME_BACK: 'Atrás',
  KH_ERROR_VIEW_MESSAGE: 'Ups! Algo salió mal. Por favor, recarga la página. Si el problema persiste, contacta con soporte.',
  KH_ERROR_VIEW_SHOW_ERROR: 'Mostrar error',
  KH_ERROR_VIEW_HIDE_ERROR: 'Ocultar error',
  KH_ERROR_VIEW_TRY_AGAIN: 'Recargar página',
  KH_NO_DATA_LOADED_ERROR_MESSAGE: 'Lo sentimos, no se han encontrado categorías o cursos disponibles. Esto puede deberse a que las categorías no han sido cargadas correctamente o que no contienen cursos. Por favor, contacta con el administrador de la plataforma para solucionar el problema.',
  KH_CONTENT_OF_INTEREST_TITLE: 'Contenido de Crehana',
  KH_THIRD_PARTY_CONTENT_TITLE: 'Contenido de Aliados',
  KH_COURSES_DYNAMIC: '{{count}} curso',
  KH_COURSES_DYNAMIC_plural: '{{count}} cursos',
  KH_TEXT_TRACK: 'Ruta',
  KH_HOME_ORG_CATEGORY_TITLE: 'Contenido de {{organizationName}}',
  KH_HOME_CREHANA_CATEGORY_TITLE: 'Contenido de Crehana',
  KH_HOME_PARTNER_CATEGORY_TITLE: 'Contenido de Aliados',
  KH_HOME_ORG_VIEW_ALL_CATALOG: 'Ingresa a todo el catálogo de **{{organizationName}}**',
  KH_HOME_CREHANA_VIEW_ALL_CATALOG: 'Todo el catálogo de **Crehana** en un solo lugar',
  KH_HOME_PARTNER_VIEW_ALL_CATALOG: 'Capacítate de la mano de nuestros **aliados**',
  KH_HOME_SUMMARY_CREHANA_CARD: 'Crehana',
  KH_HOME_SUMMARY_PARTNER_CARD: 'Aliados',
  KH_HOME_CONTENTS_LABEL: 'contenidos',
  KH_HOME_COURSES_LABEL: 'cursos',
  KH_SUBCATEGORY_IS_NEW_LABEL: 'Nuevo',
  KH_DOCUMENT_PREVIEW_TITLE: 'Vista Previa de *{{documentName}}*',
  KN_DOCUMENT_PREVIEW_ERROR_MESSAGE: 'Tu navegador no soporta la visualización de PDFs. Descarga el documento en PDF.',
  KN_DOCUMENT_PREVIEW_ERROR_SUBTITLE: 'La vista previa de este documento no está disponible',
  KN_DOCUMENT_PREVIEW_ERROR_DESCRIPTION: 'Ocurrió un error inesperado o el formato que deseas visualizar no es compatible con este visor. Haz clic en el botón para intentar cargar nuevamente.',
  KN_DOCUMENT_PREVIEW_ERROR_CTA: 'Entendido',
  KN_DOCUMENT_PREVIEW_ERROR_RETRY: 'Reintentar',
  KH_REQUIRED: 'Obligatorio',
  KH_VIRTUAL: 'Virtual',
  KH_IN_PERSON: 'Presencial',
  KH_BANNER_LEADER_TITLE: 'Como líder, puedes asignar cursos al personal a tu cargo dentro del organigrama. Accede al detalle del curso para comenzar.',
  KH_FILTER_TITLE_NEW: 'Filtrar',
  KH_FILTER_CLEAR_FILTERS: 'Limpiar Filtros',
  KH_SEE_ALL_CATEGORIES: 'Ver todos',
  KH_SELECTEDS_TITLE: 'Seleccionados',
  KH_APPLY_FILTERS: 'Aplicar',
  KH_FILTER_CATEGORIES_TITLE: 'Categorías',
  KH_FILTER_PROVIDERS_TITLE: 'Proveedor contenido',
  KH_FILTER_STATUS_TITLE: 'Estado'
});
export default es;